export const PRODUCT_CATALOG = [
  {
    app_id: "local_android_tax_calculator",
    title: "MyanTax Box - Android",
    developer: "MyanTax Box",
    category: "Finance",
    short_description: "မြန်မာ အခွန်တွက်စက်၊ အခွန်ဥပဒေ နှင့် CBM ငွေလဲနှုန်း tool အပြည့်အစုံ - offline အသုံးပြုနိုင်သည်။ အင်တာနက်မလိုပါ။",
    description: "MyanTax Box မြန်မာ Android Full Version သည် မြန်မာနိုင်ငံ အခွန်တော်ဆိုင်ရာ လုပ်ငန်းများအတွက် အပြည့်အစုံ tools စုစည်းမှုဖြစ်ပါသည်။ Offline အသုံးပြုနိုင်သောကြောင့် အင်တာနက် မလိုအပ်ပါ။ အောက်ပါ features များ ပါဝင်ပါသည် — (၁) အခွန်တွက်စက်များ: လစာ၊ ကုန်သွယ်မှု၊ အထူးကုန်ပစ္စည်း၊ ပိုင်ဆိုင်မှုနှင့် ပြည်နယ်အခွန်များအတွက် အခွန်တွက်ချက်နိုင်ပါသည်။ (၂) အခွန်ဥပဒေ ရည်ညွှန်း: ပြဋ္ဌာန်းချက်များ၊ ဥပဒေနှင့် လုပ်ထုံးလုပ်နည်းများကို အလွယ်တကူ ရှာဖွေနိုင်ပါသည်။ (၃) နှုန်းထားနှင့် ဇယားများ: လတ်တလော အခွန်နှုန်းထားများနှင့် တွက်ချက်မှု ဥပမာများ ပါဝင်ပါသည်။ (၄) ဝင်ငွေရလမ်းအမျိုးအစားများ: အခွန်ထမ်းဆောင်ရမည့် ဝင်ငွေအမျိုးအစားများကို ရှင်းပြထားပါသည်။ (၅) အရေးကြီးရက်စွဲများ: အခွန်ထမ်းဆောင်ရမည့် နောက်ဆုံးရက်စွဲများနှင့် သတိပေးချက်များ ပါဝင်ပါသည်။ (၆) CBM ငွေလဲနှုန်း Converter: ဗဟိုဘဏ် ငွေလဲနှုန်းများဖြင့် ငွေလဲနိုင်ပါသည်။ Android 7.0 (Nougat) နှင့် အထက်အတွက် သင့်တော်ပါသည်။ အသုံးပြုရန် ၁ နှစ် subscription လိုအပ်ပါသည်။",
    price_mmk: 30000,
    original_price_mmk: 35000,
    platform: "android",
    // Whether this edition is released to customers. Flip to enable on the site.
    available: true,
    version: "1.0.0",
    size_mb: 43,
    rating: 4.8,
    downloads: 0,
    icon_url: "/app-icons/myantax-icon.png",
    created_at: "2026-06-01T00:00:00.000Z",
    min_android: "7.0 (API 24)",
    build: 2001,
  },
  {
    app_id: "local_ios_tax_calculator",
    title: "MyanTax Box - iOS",
    developer: "MyanTax Box",
    category: "Finance",
    short_description: "iPhone / iPad အတွက် မြန်မာ အခွန်တွက်စက်၊ အခွန်ဥပဒေ နှင့် CBM ငွေလဲနှုန်း tool အပြည့်အစုံ - offline အသုံးပြုနိုင်သည်။",
    description: "MyanTax Box မြန်မာ iOS Full Version သည် iPhone / iPad အတွက် မြန်မာနိုင်ငံ အခွန်တော်ဆိုင်ရာ လုပ်ငန်းများအတွက် အပြည့်အစုံ tools စုစည်းမှုဖြစ်ပါသည်။ Offline အသုံးပြုနိုင်သောကြောင့် အင်တာနက် မလိုအပ်ပါ။ အောက်ပါ features များ ပါဝင်ပါသည် — (၁) အခွန်တွက်စက်များ: လစာ၊ ကုန်သွယ်မှု၊ အထူးကုန်ပစ္စည်း၊ ပိုင်ဆိုင်မှုနှင့် ပြည်နယ်အခွန်များအတွက် အခွန်တွက်ချက်နိုင်ပါသည်။ (၂) အခွန်ဥပဒေ ရည်ညွှန်း: ပြဋ္ဌာန်းချက်များ၊ ဥပဒေနှင့် လုပ်ထုံးလုပ်နည်းများကို အလွယ်တကူ ရှာဖွေနိုင်ပါသည်။ (၃) နှုန်းထားနှင့် ဇယားများ: လတ်တလော အခွန်နှုန်းထားများနှင့် တွက်ချက်မှု ဥပမာများ ပါဝင်ပါသည်။ (၄) ဝင်ငွေရလမ်းအမျိုးအစားများ: အခွန်ထမ်းဆောင်ရမည့် ဝင်ငွေအမျိုးအစားများကို ရှင်းပြထားပါသည်။ (၅) CBM ငွေလဲနှုန်း Converter: ဗဟိုဘဏ် ငွေလဲနှုန်းများဖြင့် ငွေလဲနိုင်ပါသည်။ (၆) FAQ / Help: အခွန်ဆိုင်ရာ မေးခွန်းများနှင့် အဖြေများကို အလွယ်တကူ ရှာဖွေနိုင်ပါသည်။ iOS 14.0 နှင့် အထက်အတွက် သင့်တော်ပါသည်။ အသုံးပြုရန် ၁ နှစ် subscription လိုအပ်ပါသည်။",
    price_mmk: 30000,
    original_price_mmk: 35000,
    platform: "ios",
    // iOS build is not uploaded yet. Set to true (or remove) once the .ipa is ready.
    available: false,
    version: "2.1.0",
    size_mb: 48,
    rating: 4.8,
    downloads: 0,
    icon_url: "/app-icons/myantax-icon.png",
    created_at: "2026-06-01T00:00:00.000Z",
  },
];

export function getCatalogApp(appId) {
  return PRODUCT_CATALOG.find((app) => app.app_id === appId) || null;
}

/**
 * Whether an app/edition is currently published to customers.
 * Entries without an explicit flag are treated as available.
 */
export function isAppAvailable(app) {
  return Boolean(app) && app.available !== false;
}

export function filterCatalogApps({ category = "အားလုံး", search = "", includeUnavailable = false } = {}) {
  const normalizedSearch = search.trim().toLowerCase();
  return PRODUCT_CATALOG.filter((app) => {
    if (!includeUnavailable && !isAppAvailable(app)) return false;
    const matchesCategory = !category || category === "အားလုံး" || app.category === category;
    const matchesSearch = !normalizedSearch ||
      app.title.toLowerCase().includes(normalizedSearch) ||
      app.developer.toLowerCase().includes(normalizedSearch) ||
      app.description.toLowerCase().includes(normalizedSearch);
    return matchesCategory && matchesSearch;
  });
}